import { COUNTDOWN_DEFAULT_STYLE } from '../components/ui/CountdownTimer';

export const toIsoStringFromLocalInput = (value) => {
  if (!value) return null;
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return null;
  return date.toISOString();
};

export const mapTimerSettingsToForm = (settings) => {
  const styleOverrides = settings?.style_json && typeof settings.style_json === 'object'
    ? settings.style_json
    : {};

  return {
    enabled: Boolean(settings?.timer_enabled),
    text: settings?.timer_text || 'Next CDL class starts in:',
    targetDate: formatDateTimeLocalInput(settings?.target_date),
    expireAction: settings?.expire_action || 'hide',
    style: { ...COUNTDOWN_DEFAULT_STYLE, ...styleOverrides },
  };
};

export const cloneTimerForm = (form) => JSON.parse(JSON.stringify(form));

export { COUNTDOWN_DEFAULT_STYLE };

function formatDateTimeLocalInput(isoString) {
  if (!isoString) return '';
  const date = new Date(isoString);
  if (Number.isNaN(date.getTime())) return '';

  const pad = (value) => String(value).padStart(2, '0');
  const year = date.getFullYear();
  const month = pad(date.getMonth() + 1);
  const day = pad(date.getDate());
  const hours = pad(date.getHours());
  const minutes = pad(date.getMinutes());

  return `${year}-${month}-${day}T${hours}:${minutes}`;
}
